<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card v-if="dialog">
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-card
                class="mx-auto"
                max-width="400"
              >
                <v-list>
                  <v-list-item-group v-model="firstTableId" active-class="border" color="indigo">
                    <v-list-item
                      v-for="(reservation, i) in firstTable.today_reservation"
                      :key="i"
                      :value="reservation.id"
                    >
                      <v-list-item-content >
                        <v-list-item-title v-text="reservation.date_time_visit.trim().split(' ')[1]"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card
                class="mx-auto"
                max-width="400"
              >
                <v-list>
                  <v-list-item-group v-model="secondTableId" active-class="border" color="indigo">

                    <v-list-item value="current">
                      <v-list-item-content>
                        <v-list-item-title v-text="'Занять'"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                      style="text-align: center"
                      v-for="(reservation, i) in secondTable.today_reservation"
                      :key="i"
                      :value="reservation.id"
                    >
                      <v-list-item-content>
                        <v-list-item-title  v-text="reservation.date_time_visit"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <div class="d-flex justify-center">
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-btn color="error"  block @click="resetTables">Закрыть</v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn color="blue darken-1" :loading='saving' block  @click="runTransfer" v-if="firstTableId && secondTableId">Пересадить</v-btn>
        </v-col>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "Transfer",
    mounted() {
      bus.$on('transfer', (payload) => {
       this.allTables = payload.allTables;
        this.tables = payload.tables;
        this.restaurantId = payload.restaurantId
        this.dialog = true;
      })
    },
    data() {
      return {
        firstTableId:null,
        secondTableId:null,
        allTables : [],
        restaurantId: null,
        saving: false,
        tables : [],
        dialog: false
      }
    },
    computed:{
      firstTable(){
        return this.allTables[this.tables[0]]
      },
      secondTable(){
        return this.allTables[this.tables[1]]
      }
    },
    methods:{
      runTransfer(){
        let data = {
          restaurantId : this.restaurantId,
          tables : {
            first : {
              id : this.tables[0],
              reservationId : this.firstTableId
            },
            second : {
              id : this.tables[1],
              reservationId : this.secondTableId
            }
          }
        }

        let url = '/reservation/' + this.restaurantId + '/transfer';

        axios.post(url, data)
          .then(() => {

          })
        .finally(e => {
          this.dialog = false
          this.$store.commit('map/setModeTransfer', false);
        })
      },
      resetTables(){
        this.dialog = false
      },
    }
  }
</script>

<style scoped>
  .border {
    border: 2px dashed orange;
  }
</style>
